/* External dependencies */
import { filter, Observable, switchMap } from 'rxjs';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import {
  ListUsersActions,
  ListUsersActionTypes,
  listUsersFailed,
  ListUsersRequest,
  listUsersSucceeded,
} from './action';
import { listUsersQuery } from './listUsersQuery';

export function listUsersEpic(action$): Observable<ListUsersActions> {
  return action$.pipe(
    filter((action: ListUsersActions) => action.type === ListUsersActionTypes.LIST_USERS_REQUEST),
    switchMap((action: ListUsersRequest) => listUsers(action.input).then(listUsersSucceeded).catch(listUsersFailed)),
  );
}

export async function listUsers(input) {
  console.log('📦  ListUsersInput:', JSON.stringify(input, null, 2));

  const graphQLClient = await setAuthenticatedClient();
  try {
    const { data } = await graphQLClient.query({
      query: listUsersQuery,
      variables: { input },
    });

    const { users, total } = data.listUsers;
    console.log('ListData:', users, total);

    return { users, total };
  } catch (e) {
    throw new Error('Failed to get user data');
  }
}
